import { makeStyles } from "@material-ui/core";
import { EnableStatus, statusColor } from "../../../../settings/EnableStatus";

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      padding: "20px 34px",
    },
    contentWrapper: {
      padding: "0 22px",
    },
    formWrapper: {
      marginBottom: "30px",
    },
    tableWrapper: {
      "& table": {
        fontSize: 14,

        "& thead tr th": {
          padding: theme.spacing(2),
        },

        "& tbody tr td": {
          textAlign: "left",
        },

        "& thead tr th:first-child": {
          paddingLeft: theme.spacing(0),
        },

        "& thead tr th:last-child": {
          paddingRight: theme.spacing(1),
          textAlign: "right",
        },

        "& tbody tr td:first-child": {
          paddingLeft: theme.spacing(0),
          textAlign: "left",
        },

        "& tbody tr td:last-child": {
          paddingRight: theme.spacing(1),
          textAlign: "right",
        },
      },
    },
    leftHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "nowrap",

      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.secondary.main,
    },
    roleItem: {
      display: "inline-block",
      marginBottom: 2,
      textTransform: "uppercase",
      padding: "4px 8px 2px 8px",
      borderRadius: 2,
      fontSize: 10,
      fontWeight: theme.typography.fontWeightBold,
      backgroundColor: statusColor(EnableStatus.neutral, 100),
      color: statusColor(EnableStatus.neutral, 600),
      border: `1px solid ${statusColor(EnableStatus.neutral, 200)}`,
    },
    actionItem: {
      display: "inline-block",
      marginBottom: 2,
      textTransform: "uppercase",
      padding: "8px 8px 6px 8px",
      borderRadius: 2,
      fontSize: 10,
      cursor: "pointer",
      fontWeight: theme.typography.fontWeightBold,
      color: statusColor(EnableStatus.deactivated, 600),
      backgroundColor: statusColor(EnableStatus.deactivated, 50),
      border: `1px solid ${statusColor(EnableStatus.deactivated, 100)}`,
    },
  }),
  {
    name: "admin-users-tab-panel-styles",
    flip: null,
  }
);

export default useStyles;
